<template>
  <v-dialog v-model="dialog" persistent max-width="1000px" transition="dialog-transition">
    <template v-slot:activator="{ on:dialog }">
      <v-tooltip top>
        <template v-slot:activator="{ on:tooltip }">
          <v-btn @click="getDocumentos" large dark icon v-on="{ ...tooltip, ...dialog }">
            <v-icon color="#0B3F67">mdi-file-multiple</v-icon>
          </v-btn>
        </template>
        Cargar desde Repositorio
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="pa-0">
        <ModalTitle :titulo="titulo" @cancelar="cerrar"/>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-data-table
            show-select
            item-key="repositorioId"
            :single-select="singleSelect"
            :headers="headers"
            :items="documentos"
            :items-per-page="5"
            v-model="localValue"
            seletable-key="selectableKey"
            no-data-text="No hay documento en el Repositorio"
            
            :footer-props="footer">
            <template v-slot:item.fechaRegistro="{ item }">
                {{ dateFormat(item.fechaRegistro) }}
            </template>
            <template v-slot:item.documentoId="{ item }">      
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="#0B3F67" @click="descargarDocumento(item.documentoId)">mdi-cloud-download-outline</v-icon>
                    </template>
                    Descargar
                </v-tooltip>      
            </template>
            <template v-slot:item.action="{ item }">
            <div class="d-flex flex-row">
                <ImageViewer :documentoId="item.documentoId" />
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <v-icon 
                            v-on="on" 
                            class="mr-2" 
                            color="#0B3F67" @click="borrarDocumento(item.documentoId)">
                                mdi-trash-can-outline
                        </v-icon>
                    </template>
                    Eliminar Evidencia
                </v-tooltip>
                <ModicafDoc 
                    class="mr-2" 
                    :origen="origen"
                    :documento="item.id"
                    :idDocumento="item.documentoId"
                    :inst="item.instalacion"
                    @reload="refreshTable()"/>     
            </div>         
            </template>
        </v-data-table>     
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cerrar" color="error">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>

import ImageViewer from '@/components/documentos/ImageViewerComponent.vue'
import ModicafDoc from "@/components/documentos/ModificarDocComponent"
import ModalTitle from '@/components/utils/ModalTitleComponent'
import axios from "@/axios.js"
import moment from "moment"

export default {
  components: {
    ModalTitle,
    ImageViewer,
    ModicafDoc
  },
  created() {
      axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.getters.token;
      axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
  },  
  computed: {
    indicadorActual() {
      return this.$store.getters.indicadorActual;
    }, 
    sucursal() {
      return this.$store.getters.sucursal;
    },
    localValue: {
      get() {
        return this.selected;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  props: [
        "origen",
        "anioConsulta", 
        "titulo",
        "tipoDocumento",
        "singleSelect",
        "selected",
        'notSelectable',
        'tipo'//tipo de accion
    ],
  data: () => ({
    dialog: false,
    documentos: [],
    headers: [
      { 
        text: "Acciones",
        value: "action",
        align: "center",
        align: 'center',
        width: '10%',
        sortable: false
      },
      {
        text: "Nombre",
        value: "nombre",
        align: "center",
        sortable: true
      },
      {
        text: "Origen",
        value: "origen",
        align: "center",
        sortable: true
      },
      {
        text: "Fecha Registro",
        value: "fechaRegistro",
        align: "center",
        sortable: true
      },
      {
        text: "Archivo",
        align: "center",
        sortable: false,
        value: "documentoId"
      }
    ],
    footer: {
      disableItemsPerPage: true,
      showFirstLastPage: true,
      firstIcon: "mdi-page-first",
      lastIcon: "mdi-page-last",
      prevIcon: "mdi-chevron-left",
      nextIcon: "mdi-chevron-right",
      itemsPerPageText: "Registros por página",
      itemsPerPageAllText: "Todos",
      showCurrentPage: true
    }
  }),
  methods: {
    getDocumentos() {
        this.$store.dispatch("loadingPage", true);
        axios.get(`/documento/getDataRepositorio/${this.sucursal.id}/${this.indicadorActual}/${this.anioConsulta}/${this.tipo}`).then(response => {
            this.documentos = response.data;
            if(this.notSelectable != null) {
              this.notSelectableItems()
            }
            this.$store.dispatch("loadingPage", false);
          }).catch(error => {
            if (error.request && error.request.status === 401) {
              this.$store.commit('showSessionDialog', true);
            } else {
              console.log("Error en la carga de documentos " + error);
              this.$store.dispatch("loadingPage", false);
            }
        });
    },
    dateFormat(fecha) {
        return fecha ? moment(fecha).format('DD/MM/YYYY') : '';
    },
    cerrar() {
      this.documentos = [];
      this.dialog = false;
      this.$store.dispatch("loadingPage", false);
    },
    showSelected() {
       this.$emit('input', this.selected);
    },
    notSelectableItems() {
      this.documentos = this.documentos.filter(doc =>
        !this.notSelectable.some(id => id === doc.repositorioId)
      );
    }
  }
};
</script>
